import * as React from 'react';
import MainVM from '@src/pages/main/vm';
import VMComponent from '@src/components/vm-component';
import com from '@src/utils/com';
// import Input from '@src/components/input';
import cx from 'classnames';
import Link from '@src/components/link';
import AccountInfo from '@src/components/account-info';
const styles = require('./index.less');

@com({ getInitialProps: MainVM.getInitialProps })
export default class Main extends VMComponent(MainVM) {
  renderCurrentStep() {
    const { currentStep, phone, realName, idNumLastSix, code } = this.vm.viewState;
    const { onSubmit, onValueChange, ongetPhoneCode } = this.vm.entry;
    switch (currentStep) {
      case 'verifyId':
        return (
          <table className={styles.table} align={'center'}>
            <tbody>
              <tr>
                <td className={styles.tableLable}>
                  真实姓名:<br />
                  <span className={styles.spanColor}>(2-16位汉字)</span>
                </td>
                <td className={styles.tableInput}>
                  <input
                    className={styles.input}
                    // value={realName}
                    maxLength="16"
                    size={16}
                    onChange={event => onValueChange('realName', event.target.value)}
                    ref="txt"
                  />
                  <span className={styles.spanColor}>*</span>
                </td>
              </tr>
              <tr>
                <td className={styles.tableLable}>
                  身份证后6位:<br />
                  <span className={styles.spanColor}>(身份证号后6位)</span>
                </td>
                <td className={styles.tableInput}>
                  <input
                    className={styles.input}
                    value={idNumLastSix}
                    maxLength="6"
                    size={16}
                    onChange={event => onValueChange('idNumLastSix', event.target.value)}
                  />
                  <span className={styles.spanColor}>*</span>
                </td>
              </tr>
              <tr>
                <td className={styles.tableSubmit} colSpan="2">
                  <input type="button" value="提   交" className={styles.button} maxLength="16" size={20} onClick={() => onSubmit(currentStep)} />
                </td>
              </tr>
            </tbody>
          </table>
        );
      case 'bindPhone':
        return (
          <table className={styles.table} align={'center'}>
            <tbody>
              <tr>
                <td className={styles.tableLable}>
                  手机:<br />
                  <span className={styles.spanColor}>(1[3/4/5/6/7/8/9]开头)</span>
                </td>
                <td className={styles.tableInput}>
                  <input className={styles.input} maxLength="12" size={16} value={phone} onChange={event => onValueChange('phone', event.target.value)} />
                  <span className={styles.spanColor}>*</span>
                </td>
              </tr>
              <tr>
                <td className={styles.tableLable}>
                  验证码:<br />
                  <span className={styles.spanColor}>(6位数字)</span>
                </td>
                <td className={styles.tableInput}>
                  <input className={styles.input} maxLength="6" size={16} value={code} onChange={event => onValueChange('code', event.target.value)} />
                  <input type="button" value="获取验证码" className={styles.inputButton} onClick={ongetPhoneCode} />
                  <span className={styles.spanColor}>*</span>
                </td>
              </tr>
              <tr>
                <td className={styles.tableSubmit} colSpan="2">
                  <input type="button" value="绑   定" className={styles.button} maxLength="16" size={20} onClick={() => onSubmit(currentStep)} />
                </td>
              </tr>
            </tbody>
          </table>
        );
      case 'complete':
        return (
          <div className={styles.complete}>
            <p>恭喜您</p>
            <p>手机绑定成功</p>
          </div>
        );
      default:
        return null;
    }
  }

  render() {
    const vm = this.vm;
    const { entry, viewState, computes } = vm;
    const { stepperBind, currentStep, account } = viewState;
    const { onExitClick, onLoginClick } = entry;
    return (
      <div className={styles.root}>
        <div className={styles.stepperGroup}>
          <span className={styles.tipSpan}>······</span>
          {stepperBind.map((item, index) => {
            return (
              <div className={cx(styles.step, currentStep === item.key && styles.stepActive)} key={index}>
                {item.title}
                <span className={cx(styles.tipSpan, item.key === 'complete' && styles.hidden)}>···>···</span>
              </div>
            );
          })}
          <span className={styles.tipSpan}>······</span>
          <div className={styles.info}>
            <AccountInfo username={account} onLogoutClick={onExitClick} onLoginClick={onLoginClick} />
          </div>
        </div>

        <div className={styles.currentStepper}>{this.renderCurrentStep()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/main/index.js